import { useNavigate } from "react-router-dom";
import { ModuleRow } from "@/mobile/ui";
import { moduleHref } from "@/mobile/open";

export function MobileModuleList({ groups }) {
  const nav = useNavigate();
  return (
    <div className="pb-6" data-testid="mobile-modules">
      {groups.map((g) => (
        <section key={g.key}>
          <h2 className="px-3 pt-4 pb-1.5 text-[12px] font-bold uppercase tracking-wide text-[var(--m-muted)]">{g.label}</h2>
          <div className="divide-y divide-[var(--m-border)] border-y border-[var(--m-border)]">
            {g.modules.map((m) => (
              <ModuleRow key={m.to} module={m} onClick={() => nav(moduleHref(m))} sub={m.children?.length ? `${m.children.length} pages` : null} />
            ))}
          </div>
        </section>
      ))}
    </div>
  );
}

export function MobileSubmenu({ module: m, section }) {
  const nav = useNavigate();
  if (!m) {
    return <div className="p-6 text-center text-[14px] text-[var(--m-muted)]">This menu isn't available for your account.</div>;
  }
  return (
    <div className="pb-6" data-testid="mobile-submenu">
      <div className="px-3 pt-3 pb-2 text-[13px]">
        <button type="button" onClick={() => nav("/")} className="text-[var(--m-link)]">Home</button>
        {section && (<><span className="mx-1 text-[var(--m-muted)]">›</span>
          <button type="button" onClick={() => nav(`/?sec=${section.key}`)} className="text-[var(--m-link)]">{section.label}</button></>)}
        <h1 className="text-[20px] font-bold mt-1" style={{ fontFamily: "Manrope" }}>{m.label}</h1>
      </div>
      <div className="divide-y divide-[var(--m-border)] border-y border-[var(--m-border)]">
        {m.children.map((c) => (
          <ModuleRow key={c.to} module={{ ...c, icon: c.icon || m.icon }} onClick={() => nav(c.to)} />
        ))}
      </div>
    </div>
  );
}
